<template>
  <Form 
    :d_form='form'
    :d_penderma='penderma'
    :d_pejantan='pejantan'
    v-if="id > 0 && load == 3"
  /> 
  <Form 
    :d_form='form'
    :d_penderma='penderma'
    :d_pejantan='pejantan'
    v-else-if="id == 0 && load == 2"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.pemungutan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Pendaftaran IBVK', route: '/se/pemungutan' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        tarikh : '',
        no_batch: '',
        tarikh_pengeluaran : 0,
        id_ternakan : '',
        nama_ternakan: '',
        baka: '',
        negara : '',
        jumlah_straw: '',
        se_katalog_induk_id:'',
        id_ternakan_penderma:'',
        nama_penderma_ternakan:'',
        penderma_baka:'',
        harga:0,
        hantar: 2
      },
      form1:[],
      se_pengeluaran : [],
      pejantan:[],
      penderma:[],
      negeri: [],
      load : 0
      
      
    }
  },
  methods: {
    
    getGetPejantan(){
      this.$zcomm.get(this.api_service + 'lookup/embrio_katalog/j', {}).then(res => {
        this.pejantan = res
        this.load = this.load + 1
      })
    },
    getGetPenderma(){
      this.$zcomm.get(this.api_service + 'lookup/embrio_katalog/p', {}).then(res => {
        this.penderma = res
        this.load = this.load + 1
      })
    },
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'se_pendaftaran/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getGetPejantan()
    this.getGetPenderma()
    
  }
    
}
</script>
